import React from 'react';
import styled from 'styled-components';

function ArticleNum({number, title}) {
  return (
    <Numberwrap>
        <div className="line"></div>
        <div className="num">{number}</div>
        <div className="title fs-1 ">{title}</div>
    </Numberwrap>
  );
}

const Numberwrap = styled.div`
    display: flex;
    align-items: center;

    .line{
        border-bottom: 3px solid black;
        width: 3rem;
        margin-right: 0.5rem;
    }
    .num{
        color: var(--secondary);
        font-family: "Abril Fatface", cursive;
        font-size: 2.3rem;
        line-height: 1;
        margin-right: 2rem;
    }
    .title{
        color: var(--primary);
    }
    @media only screen and (max-width: 500px){
        .line{
            width: 2rem;
        }
    }
`;

export default ArticleNum;